(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }
  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;
      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;
          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }
        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) { this.isAtTop = false; }
      if (this.isAtTop) { this.currentScrollTop = scrollTop; return; }
      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);
            this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      } else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          requestAnimationFrame(this.hide.bind(this));
          setTimeout(() => { requestAnimationFrame(this.reveal.bind(this)); }, 300);
        } else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ll-before-after-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('input',function(event){
  var slider=event.target;
  if(!slider.classList.contains('llba__slider'))return;
  var comparison=slider.closest('.llba__compare');
  if(comparison)comparison.style.setProperty('--llba-position',slider.value+'%');
});
function llMoveHairBeforeAfterUnderIntro(){
  var comparisons=document.querySelectorAll('.llba[data-llba-after-intro="1"]');
  if(!comparisons.length)return;
  var accordions=document.querySelectorAll('.section-ll-longdesc .ll-block > details.ll-acc');
  for(var i=0;i<accordions.length;i++){
    var summary=accordions[i].querySelector('summary');
    if(!summary||summary.textContent.trim()!=='Mi az a Hajmegújító szérum?')continue;
    comparisons.forEach(function(comparison){
      var sliderSection=comparison.closest('.ll-before-after-section');
      if(sliderSection&&accordions[i].nextElementSibling!==sliderSection){
        accordions[i].insertAdjacentElement('afterend',sliderSection);
      }
    });
    break;
  }
}
if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',llMoveHairBeforeAfterUnderIntro,{once:true});
}else{
  llMoveHairBeforeAfterUnderIntro();
}
document.addEventListener('shopify:section:load',llMoveHairBeforeAfterUnderIntro);
document.addEventListener('shopify:section:unload',function(event){
  var target=event.target;
  if(!target||!target.classList||!target.classList.contains('section-ll-longdesc'))return;
  var slider=target.querySelector('.llba[data-llba-after-intro="1"]');
  var sliderSection=slider&&slider.closest('.ll-before-after-section');
  if(sliderSection)target.insertAdjacentElement('afterend',sliderSection);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ll-nmn-story"] && !Shopify.designMode) return;
  try {
    
function llNmnPositionIntroStory(){
  var stories=document.querySelectorAll('.llnmn-hero[data-llnmn-after-intro="1"]');
  if(!stories.length)return;
  var details=document.querySelectorAll('.section-ll-nmn-details .ll-block > details.ll-acc');
  for(var i=0;i<details.length;i++){
    var summary=details[i].querySelector('summary');
    if(!summary||summary.textContent.trim()!=='Mi az NMN arcszérum?')continue;
    stories.forEach(function(story){
      var section=story.closest('.ll-nmn-story-section');
      if(section&&details[i].nextElementSibling!==section)details[i].insertAdjacentElement('afterend',section);
    });
    break;
  }
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',llNmnPositionIntroStory,{once:true});
else llNmnPositionIntroStory();
document.addEventListener('shopify:section:load',llNmnPositionIntroStory);
document.addEventListener('shopify:section:unload',function(event){
  if(!event.target?.classList?.contains('section-ll-nmn-details'))return;
  var story=event.target.querySelector('.llnmn-hero[data-llnmn-after-intro="1"]');
  var section=story&&story.closest('.ll-nmn-story-section');
  if(section)event.target.insertAdjacentElement('afterend',section);
});

function llNmnInitComparison() {
  document.querySelectorAll('.llnmn-hero__compare[data-llnmn-compare]').forEach(function(frame) {
    if(frame.dataset.compareReady === '1')return;
    var slider=frame.querySelector('.llnmn-hero__range');
    if(!slider)return;
    frame.dataset.compareReady='1';
    function draw(){
      var percentage=Math.min(100,Math.max(0,parseFloat(slider.value)||0));
      frame.style.setProperty('--llnmn-split',percentage+'%');
      slider.setAttribute('aria-valuetext',String(Math.round(percentage))+' százalék az előtte fotóból');
    }
    slider.addEventListener('input',draw);
    slider.addEventListener('change',draw);
    draw();
  });
}
if(document.readyState === 'loading')document.addEventListener('DOMContentLoaded',llNmnInitComparison,{once:true});
else llNmnInitComparison();
document.addEventListener('shopify:section:load',llNmnInitComparison);

  } catch(e) { console.error(e); }
})();
})();
